import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IUserMast } from "../../models/UserMast";
import { Checkbox } from "primereact/checkbox";
import { IRequirementMast } from "../../models/RequirementMast";
import { IAllocateRequirement_mast } from "../../models/AllocateRequirement_mast";
import { IAllRequirements } from "../../models/AllRequirements";
import { Search } from "../../shared/Search";
import { JVInput } from "../../shared/JVInput";
import { ILogin } from "../../models/Login";

interface Iprops {
    singleData: IAllRequirements
    open: boolean,
    hideDialog: () => void,
    toast: any,
    roles?: Array<number>
}

interface IRFAL {
    vendor_Name?: string,
    consultant_Name?: string
}
const EmptyRFAL: IRFAL = {
    vendor_Name: "",
    consultant_Name: ""
}

const schema = yup.object({
    vendor_Name: yup.string().required("Vendor Name is required*"),
    consultant_Name: yup.string().required("Consultant Name is required*")
});

export const Allocate = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState<Array<IUserMast>>([]);
    const [tData, setTData] = useState<Array<IUserMast>>([]);
    const [search, setSearch] = useState<string | null>(null);

    const [data, setData] = useState<IRequirementMast>();
    const [rfoalloc, setRfoalloc] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IRFAL>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRFAL
    });
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    useEffect(() => {
        if (props.singleData.req_ID) loadData();
    }, [props.singleData.req_ID]);

    const loadData = async () => {
        setLoading(true);
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
            setLoading(false);
        } else setLoading(false);
    }

    useEffect(() => {
        setLoading(true);
        if (search) {
            const temp = tableData.filter((td) => td.user_Name?.toUpperCase().includes(search.toUpperCase()));
            setTData(temp);
            setLoading(false);
        } else {
            setTData(tableData);
            setLoading(false);
        }
    }, [search]);

    const saveToDB = async () => {
        setLoading(true);
        const data: Array<IAllocateRequirement_mast> = [];
        tableData.forEach(e => {
            if ((!e.is_allocated && e.req_ID !== 0) || (e.is_allocated && e.req_ID === 0)) {
                const _obj: IAllocateRequirement_mast = {
                    req_ID: props.singleData.req_ID ?? 0,
                    recruiter_ID: e.login_ID ?? 0,
                    remove: (!e.is_allocated && e.req_ID !== 0) ? true : false
                }
                data.push(_obj);
            }
        });
        if (data.length > 0) {
            const response = await Fetch("AllocateRequirement_mast", "POST", data, null, props.toast);
            if (response) {
                onHide();
                props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            }
        } else props.toast.current.show({ severity: 'error', detail: "Select Recruiter to Allocate", life: 3000 });
        setLoading(false);
    }

    const loadTableData = async () => {
        setLoading(true);
        const response = await Fetch("AllocateRequirement_mast", "GET", null, `requirement_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: Array<IUserMast> = await response.json();
            if (data[0]?.role_ID === 0 && data[0]?.login_ID === 0) {
                if (data[0]?.user_Name === "RequestForAllocation") {
                    delete data[0];
                    const _data: Array<IUserMast> = [];
                    data.forEach(e => {
                        e.is_allocated = e.req_ID !== 0;
                        _data.push(e);
                    });
                    setTableData(_data);
                    setTData(_data);
                    setRfoalloc(true);
                    props.toast.current.show({ severity: 'info', detail: "This requirement already working enough resources if you would like to work on it please click on send request button for allocation." });
                } else {
                    props.toast.current.show({ severity: 'error', detail: data[0]?.user_Name });
                    const _data: Array<IUserMast> = [];
                    data.forEach((e, i) => {
                        if (i !== 0) {
                            e.is_allocated = e.req_ID !== 0;
                            _data.push(e);
                        }
                    });
                    setTableData(_data);
                    setTData(_data);
                }
            } else {
                const _data: Array<IUserMast> = [];
                data.forEach(e => {
                    e.is_allocated = e.req_ID !== 0;
                    _data.push(e);
                });
                setTableData(_data);
                setTData(_data);
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const onHide = () => {
        props.hideDialog();
        setTData([]);
    }

    const onCheckChange = (login_ID?: number) => {
        let data = [...tableData];
        if (login_ID !== undefined) {
            for (var i in data) {
                if (data[i].login_ID === login_ID) {
                    data[i].is_allocated = !data[i].is_allocated;
                    break;
                }
            }
        }
        setTableData(data);
    }

    const checkBodyTemplate = (rowData: IUserMast) => {
        if (props.roles?.includes(1) || props.roles?.includes(26)) {
            return (
                <Checkbox onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
            );
        } else if (props.roles?.includes(2) || props.roles?.includes(4) || loginObj.is_Team_Lead) {
            if (rowData.req_ID) {
                return (
                    <Checkbox disabled onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
                );
            } else {
                return (
                    <Checkbox onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
                );
            }
        } else {
            if (rowData.req_ID) {
                return (
                    <Checkbox disabled onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
                );
            } else {
                if (tableData.length <= 3) {
                    return (
                        <Checkbox onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
                    );
                } else {
                    return (
                        <Checkbox disabled onChange={() => onCheckChange(rowData.login_ID)} name={rowData.login_ID?.toString()} checked={rowData.is_allocated} ></Checkbox>
                    );
                }
            }
        }
    };

    const headerTemplate = () => {
        return <div style={{ display: 'flex' }}>
            <span className="mr-3">Allocate Requirment</span>
            <span><Search setSearch={setSearch} removeIcon /></span>
        </div>
    }

    const footerTemplate = () => {
        let showFooter = false;
        for (let index = 0; index < tData.length; index++) {
            if (!tData[index].req_ID) {
                showFooter = true;
                break;
            }
        }
        return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            {showFooter && <> <Button loading={loading} className="p-button-sm my-1" label="SUBMIT" type="button" onClick={saveToDB}></Button>
                <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button></>}
        </div>
    }

    const location = (rowData: IRequirementMast) => {
        return (
            <>{rowData?.city_Name + ", " + rowData?.state_Name}</>
        );
    };

    async function requestForAllocation(data: IRFAL) {
        const response = await Fetch("AllocateRequirement_mast/requestAllocation", "POST", null, `req_id=${props.singleData.req_ID}&vendor_Name=${data.vendor_Name}&consultant_Name=${data.consultant_Name}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Request for allocation is sent successfully.", life: 3000 });
            setRfoalloc(false); reset();
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '500px' }} header={headerTemplate} footer={footerTemplate} className="p-fluid" onHide={onHide}>
            <Dialog visible={rfoalloc} style={{ width: '500px' }} header="Request for Allocation" className="p-fluid" onHide={() => { setRfoalloc(false); reset(); }}>
                <form onSubmit={handleSubmit(requestForAllocation)} className="p-fluid formgrid grid">
                    <JVInput column={1} required label="Vendor Name" control={control} name="vendor_Name" error={errors.vendor_Name?.message} />
                    <JVInput column={1} required label="Consultant Name" control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
                    <div className="field col-12 md:col-12" ><Button label="SEND REQUEST FOR ALLOCATION" type="submit"></Button></div>
                </form>
            </Dialog>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={[data]} loading={loading}
            >
                <Column field="req_ID" header="Req.ID" />
                <Column field="req_PostedBySalesManager_Name" header="Sales Manager" />
                <Column field="req_Job_Title" header="Job Title" />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" body={location} />
            </DataTable>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tData}
                emptyMessage="Not Available"
                loading={loading}
            >
                <Column body={checkBodyTemplate} headerStyle={{ width: '5%' }} />
                <Column field="user_Name" header="Name" headerStyle={{ width: '15%' }} />
                <Column field="role_Name" header="Role" headerStyle={{ width: '15%' }} />
            </DataTable>
        </Dialog>
    );
}
